export const lang_en = {
    appBar: {
        pdf_tooltip: "Download PDF instructions",
        video_tooltip: "Open video instructions"
    },
    appModalTitle: "Error",
    btnCancel: "Cancel",
    btnClose: "Close",
    btnSave: "Save",
    common: {
        dateFrom: "Start date",
        dateTo: "End date",
        dialog_cancel_btn: "Cancel",
        dialog_ok_btn: "OK",
        dialog_title: "Confirmation",
        progress_bar_text: "Please wait...",
        remark: "Note",
        contact: 'Contact'
    },
    digital_certificates: {
        no_data: 'No seminars for which digital certificates can be downloaded',
        instructions_popup: 'In order to download certificates pop-up windows must be enabled',
        subtitle: 'Download certificate by clicking on the row',
    },
    documents: {
        download: {
            or_more: "(or more)",
            number_of_files: "number of additional materials for download",
            zero_files: "no additional materials for download",
            file_does_not_exist: "The file does not exist",
            file_exists: "The file exists",
            additional_documents: "Additional materials",
            additional_documents_modal_title: "Additional materials for: {education}",
            additional_documents_not_found: "No additional materials were found for this service",
            download_success: "Download successful",
            no_documents: "No documents",
            seminar_download: "Download seminar assignment",
            seminar_download_not_found: "No seminar assignment was found for this service",
            tooltip: "Click to download document",
            tooltip_show: "Click to view additional documents",
            digital_manuals: "Digital manuals"
        },
        upload: {
            available_services: "Available services",
            enrollment_expired: "Enrollment has expired",
            file_not_selected: "You must choose a file and education from the select list",
            file_upload_label: "Select file",
            program_not_selected: "Service must be selected",
            less_then_limit_title: "Sending solution up to {n} MB",
            more_then_limit_title: "Sending solution larger then {n} MB",
            more_then_limitA: "1. 1. If Your seminar assignment is available on the Internet (e.g. Web site), upload .txt file (Notepad) instead",
            more_then_limitB: "2. The file must contain valid link to the seminar assignment.",
            more_then_limitC: "3. If download requires more data (e.g.username and password), add them to the same .txt file.",
            more_then_limit2_1: "1. If Your file is larger than {n} mb, and is not available on the Internet, compress it into ONE ZIP file and upload it to one of the fileshare services stated below.",
            more_then_limit2_2: "2. Here, instead of the seminar assignment, upload .txt file with a valid link to your assignment.",
            more_then_limit2_3: "3. If download requires username and password, add those data in the same .txt file.",
            more_then_limit2_40: "(up to {size})",
            more_then_limit2_41: "Free fileshare services which can be used:",
            seminar_instruction1_1: "1. Your seminar assignment will be checked within within 30 days of the submission date",
            seminar_instruction1_2: "2. On this page/HERE, You can check if the assignment has been fulfilled, and if Your e-mail address is in the system, You will be notified.",
            seminar_instruction2_1: "3. The seminar assignment that You have downloaded is in PDF format within a compressed file.",
            seminar_instruction2_2: "4. To open the assignment, You need to have a PDF reader and a decompression tool.",
            title_available_internet: "Available on the Internet:",
            title_unavailable_internet: "Not available on the Internet:",
            title_instructions: "Other instructions",
            upload: "Upload",
            upload_email_error: "Seminar assignment uploaded, but mentor was not notified",
            upload_error: "Upload failed. Error while saving data",
            upload_success: "Upload successful"
        },
        history: {
            title: "Status history (choose a service from the drop-down menu)",
            status_name_1: "Downloaded",
            status_name_2: "Received",
            status_name_3: "Examined - INCORRECT",
            status_name_4: "Examined - CORRECT",
            table_header_date: "Date of change in status",
            table_header_status: "Status",
            table_header_comment: "Comment",
            table_header_mentor: "Mentor"
        }
    },
    ev_lista: {
        table_view_headers: {
            event_date: "Date",
            event_name: "Name",
            event_lecturer: "Lecturer",
            event_presence: "Presence",
            event_status: "Status"
        },
        exam_result: {
            _1: 'Pass',
            _2: 'Fail',
            _3: 'Didn\'t attend the exam',
            _4: "Waiting for exam evaluation",
            _5: ''
        },
        my_q_test_results_link_title: "Show my all exam results"
    },
    exam_register: {
        address: 'Address',
        classroom: 'Classroom',
        city: "City",
        city_not_selected: "City not selected",
        confirm_button: 'I want to register',
        confirm_registration: "Do You want to register for an exam: {name} for term: {date_time} and spend one credit?",
        credits_state: "Number of credits' STATUS",
        credits_overall: "Total",
        credits_available: "Available",
        credits_used: "Used",
        exam_succesfully_registered: "Exam successfully registered",
        exam_term_register_notice1: "Exam registration deadline",
        exam_term_register_notice2: "days before term",
        exam_term_unregister_notice1: "Exam unregister deadline",
        exam_term_unregister_notice2: "working days before term",
        exam_succesfully_registered_email_subj: 'Exam registration',
        exam_succesfully_registered_email_body: 'You have an exam registration for {education}, location: {city}. Exam start date: {date} {term}',
        exam_demo_btn: 'Request a demo exam',
        exam_demo_info: 'By clicking on the button, you will be sent user data for accessing the demo exams on the MyQTest exam system.',
        exam_demo_success: 'User data has been sent successfully.',
        exam_demo_error: 'An error occurred while sending the email. Please try again.',
        no_education_data: "No exam can be registered.",
        service_select_text: "Available services for exam registration",
        show_exams_terms: "Show exam terms",
        subtitle: "Select and register for the exam",
        terms_table: {
            btn_register_exam: "Register"
        },
        terms_table_headers: {
            term_date: "Date",
            term_time: "Time",
            classroom: "Classroom",
            address: "Address"
        }
    },
    exam_unregister: {
        confirm_button: 'I want to cancel my exam registration',
        confirm_cancelation: "Do You want to cancel the registration for education: {name}, term {date_time}?",
        exam_start: "Run exam",
        subtitle: "Exam terms for which a minimal deadline for cancellation has expired are not shown.",
        terms_table: {
            btn_unregister_exam: "Cancel exam registration"
        },
        terms_table_headers: {
            term_date: "Date",
            term_time: "Time",
            education_name: "Service",
            address: "Address",
            classroom: "Classroom"
        }
    },
    guides: {
        link1: 'Guide for classroom attendants',
        link2: 'Guide for online attendants',
        link3: 'Guide for self-learning',
        link4: 'Universal requirements',
        link5: 'Code of Ethics',
    },
    materials_and_docs: {
        subtitle: "Seminar assignment and additional materials"
    },
    menu_additional_documents: "Additional materials",
    menu_certificate_claim: "Certificate Claim",
    menu_surveys: "Surveys",
    menu_digital_cerficates: "My Digital Certificates",
    menu_education_deadline: "Education Deadline",
    menu_guides: 'Guidebooks and requirements',
    menu_exam_register: "Exam registration",
    menu_exam_unregister: "Exam start or registration cancellation",
    menu_education: "Education | EDUCATION",
    menu_my_education: "Education and invoices",
    menu_my_schedule: "My Schedule",
    menu_password_change: "Password Change",
    menu_presence_exam_results: "Attendance And Exam Results",
    menu_seminar_task_download: "Download materials",
    menu_seminar_task_upload: "Upload seminar assignment",
    menu_login: "Login",
    my_education: {
        subtitle: "",
        invoice_text: 'Invoices'
    },
    my_schedule_view: {
        classroom: "Classroom",
        title: "My schedule",
        subtitle_table: "Table view",
        subtitle_calendar: "Calendar view",
        subtitle_timeline: "Timeline view",
        switch_btn_to_calendar: "Show calendar",
        switch_btn_to_table: "Show table",
        switch_btn_to_timeline: "Show timeline",
        notification: 'NOTIFICATION!',
        dear_students: 'Dear students,',
        new_mob_app: 'you can download new mobile app from Google or Apple mobile app store or from the following links:',
        table_view_headers: {
            id: "No",
            event_date: "Date",
            seminar: "Seminar",
            classroom: "Classroom"
        }
    },
    OIB_info: {
        info1: "U bazi nedostaje Vaš OIB.",
        info2: "Kako biste mogli prijaviti i polagati ispite te pregledavati detalje rezultata, potrebno je upisati OIB.",
        info3: "Nakon spremanja OIB-a, moći će te vidjeti termine i prijaviti ispite, a na dan ispita, stranica",
        info4: "za odjavu i pokretanje ispita prikazat će opcije za pokretanje ispita.",
        greska_OIB: "Niste upisali ispravan OIB",
        uspjeh_OIB: "OIB uspješno spremljen"
    },
    page_404: "404 - Page not found",
    page_404_descr: "The page you are trying to reach, does not exist",
    program_deadline: {
        available_services: "Available services",
        extensions: 'Extensions',
        enrolment_expired: 'YES | NO',
        subtitle: '',
        table_headers: {
            days: 'Days',
            enrollment_deadline_expiration: 'Enrollment expiry date',
            enrollment_expired: 'Enrollment expired',
            program_duration: 'Program duration',
            start_date: 'Start date',
        },
        table_extension_headers: {
            end_date: 'Extension end',
            start_date: 'Extension start',
        }
    },
    security_login_dialog: {
        instructions_reset_pass: 'Enter username and click Send. New password will be sent to Your email.',
        password_forgoten_title: 'Forgotten password',
        password_forgoten_1: 'If You are not able to enter the new password, contact us at 01/2222-160 or',
        password_forgoten_2: 'info@algebra.hr',
        password_forgoten_3: 'so we can reset the password and email You the new one.',
        reset: 'Send',
        cancel: 'Cancel',
        back: 'Back',
        reports_and_requests_title: 'Registrations and requirements',
        reports_and_requests_school_status: 'Request for school status regulation',
        request_cert: 'Issuing a certificate',
        username_missing: 'Username or email address must be entered'
    },
    security: {
        _401_msg: "Unathorized, login timeout expired. Please log in again",
        _500_msg: "No access to resources. Please log in again",
        btnSignIn: "LOGIN",
        btnSignOut: "LOGOUT",
        login_descr: "Attendants' portal login",
        login_title: "Enter username or email address to log in",
        login_error: "Validation error, check input",
        password: "Password",
        password_change_descr: "Fill in all input fields and Save changes",
        password_NEW: "New password",
        password_NEW_repeat: "Repeat new password",
        password_NEW_repeat_err: "Passwords do not match",
        password_OLD: "Old password",
        password_noMatch: "Passwords do not match",
        rules: {
            title: "Password must meet following requirements:",
            password_characters: "Can contain lowercase and UPPERCASE letters of English alphabet, and numbers",
            password_characters_rules: "Must contain at least one lowercase letter, one UPPERCASE letter, and one digit",
            password_length: "Must contain at least {count} characters"
        },
        username: "Username",
        username_or_email: 'Username or e-mail'
    },
    server_msg: {
        account: {
            deactivated: "Your account has been deactivated. Please contact Algebra.",
            email_wrong: 'Email address does not exist',
            password_changed: 'Password successfully changed',
            password_change_success: 'Password succesfully change',
            username_does_not_exist: 'Username does not exist',
            email_is_null: 'Email address not found for this user account',
        },
        digital_certificates: {
            missing_data: 'Certiticate couldn\'t be created, missing data!'
        },
        documents_download: {
            file_does_not_exist: "File not found",
            no_defined_seminar_task: "Selected education doesn't have defined seminar task"
        },
        ev_lista: {
            present: 'Present',
            absent: 'Absent'
        },
        exam_register: {
            deadline_ended: 'Exam must be registered within the defined program term deadline, or term extension period',
            max_signup: "This exam term reached the maximum number of signups. Please select a different term.",
            missing_date: "Date not selected",
            no_history_id: "No exam can be registered.",
            program_ended: "Program term deadline has expired",
            term_occupied: "You have already registered for this exam term",
            term_has_expired: 'The exam registration must be done at least 20 days before the exam term.<'
        },
        exam_unregister: {
            exam_cancelled: "Exam registration successfully cancelled"
        },
        login: {
            invalid_token: "Login failure: token is not valid",
            too_many_times: "Wrong password entered too many times. Your password has been changed. Please contact Algebra for password reset.",
            wrong_pass_or_user: "Wrong username or password"
        },
        seminar_upload: {
            task_already_exists: "Assignment has already been uploaded",
            upload_email_error: "The file has been uploaded successfully, but e-mail to mentor hasn't been sent"
        }
    },
    validate: {
        required_entry: "Entry is required",
        required_select: "Selection is required"
    },
    title_attendants_portal: "Attendants portal",
    validation_noSpaces: "Blank space characters are not allowed",

    $vuetify: {
        dataTable: {
            rowsPerPageText: "Rows per page:",
            pageText: "{0}-{1} of {2}"
        },
        dataIterator: {
            rowsPerPageText: "Rows per page:",
            rowsPerPageAll: "All",
            pageText: "{0}-{1} of {2}"
        },
        noDataText: "No data"
    }
};



// WEBPACK FOOTER //
// ./VueSrc/Common/plugins/translations/en.js